import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	standardOfferCalendarTitle: {
		id: 'upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.title',
		defaultMessage: 'Balance deadlines and downtime',
		description: 'Title for the Standard Offer Calendar modal',
	},
	standardOfferCalendarSubtitle: {
		id: 'upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.subtitle',
		defaultMessage:
			'Bring schedules and work together with team calendars. Try Standard free for 14 days.',
		description: 'Subtitle for the Standard Offer Calendar modal',
	},
	calendarBenefitsTrack: {
		id: 'upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.calendarBenefitsTrack',
		defaultMessage: "Track who's doing what and when",
		description: 'First message for the Standard Offer Calendar modal',
	},
	calendarBenefitsSeeDeadlines: {
		id: 'upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.calendarBenefitsSeeDeadlines',
		defaultMessage: 'See deadlines alongside key events',
		description: 'Second message for the Standard Offer Calendar modal',
	},
	calendarBenefitsLinkEvents: {
		id: 'upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.calendarBenefitsLinkEvents',
		defaultMessage: 'Link events to spaces and pages',
		description: 'Third message for the Standard Offer Calendar modal',
	},
	standardOfferCalendarDisclaimerText: {
		id: 'upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.disclaimerText',
		defaultMessage:
			'Free 14-day Standard plan trial. Cancel or downgrade anytime. We’ll remind you before your trial ends.',
		description: 'Disclaimer text for the Standard Offer Calendar modal',
	},
	standardOfferCalendarPrimaryCTA: {
		id: 'upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.primaryCTA',
		defaultMessage: 'Try it free',
		description: 'Primary CTA text for the Standard Offer Calendar modal',
	},
	standardOfferCalendarSecondaryCTA: {
		id: 'upgrade-free-pool-target-experiment.Standard-Offer-Calendar-Modal.secondaryCTA',
		defaultMessage: 'Not now',
		description: 'Secondary CTA text for the Standard Offer Calendar modal',
	},
});
